// extracted by mini-css-extract-plugin
module.exports = {"ItemsPerPage":"ItemsPerPage_ItemsPerPage__3OKei","PageSizes":"ItemsPerPage_PageSizes__1lMDQ","Label":"ItemsPerPage_Label__2i3Ba"};